import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CustomerType } from 'components/common/CommonTypes';

type CustomerState = CustomerType;

export const customerSlice = createSlice({
    name: 'customer',
    initialState: {} as CustomerState,
    reducers: {
        setCustomer: (_, action: PayloadAction<CustomerType>) => action.payload,
        setEmail: (state, action: PayloadAction<string>) => {
            state.email = action.payload;
        },
        setAddress: (state, action: PayloadAction<CustomerType['address']>) => {
            state.address = action.payload;
        },
        setBankDetails: (
            state,
            action: PayloadAction<CustomerType['bankDetail']>
        ) => {
            state.bankDetail = action.payload;
        }
    }
});

export const { setCustomer, setAddress, setBankDetails, setEmail } =
    customerSlice.actions;
